/**
 * Documents and folders: `docs:` / `d:` / `doc:` / `document:` / `documents:` / `page:` — titles, tags, path, and (desktop) the text inside, as a snippet.
 * Backed by the local search index (PLAN §12.2) through `deps.client`
 * (`index/indexClient.js` on desktop, `index/webIndexClient.js` on web).
 */
import { FileText } from 'lucide-react';
import { createIndexProvider } from '../index/indexProvider';

export const SPEC = Object.freeze({ id: 'documents', kinds: ['document', 'folder'], prefixes: ['docs', 'd', 'doc', 'document', 'documents', 'page'], labelKey: 'palette.scope.documents', icon: FileText, order: 70, page: 'documents.panel', body: true });

/** @param {{ client: object }} deps */
export default function create(deps) {
  return createIndexProvider(SPEC, deps);
}
